var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-buttons" },
    [
      _c(
        "van-row",
        [
          _vm._l(_vm.showBtns, function (btn, index) {
            return _c(
              "van-col",
              { key: index, attrs: { span: _vm.span } },
              [
                _c(
                  "van-button",
                  {
                    class: [btn.className],
                    attrs: {
                      type: btn.buttonType
                        ? btn.buttonType
                        : index === 0
                        ? "info"
                        : "default",
                      disabled: btn.disabled,
                      block: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.btnClick(btn)
                      },
                    },
                  },
                  [_vm._v(_vm._s(btn.name))]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.more
            ? _c(
                "van-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { block: "", square: "" },
                      on: {
                        click: function ($event) {
                          _vm.actionPopup = true
                        },
                      },
                    },
                    [_c("van-icon", { attrs: { name: "weapp-nav" } })],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.more
        ? _c("van-action-sheet", {
            attrs: { actions: _vm.actions, "get-container": "body" },
            on: { select: _vm.onActionSelect },
            model: {
              value: _vm.actionPopup,
              callback: function ($$v) {
                _vm.actionPopup = $$v
              },
              expression: "actionPopup",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }